export const ENVELOPE_VERSION = 1;
const encoder = new TextEncoder();
const decoder = new TextDecoder();
export function encodeEnvelope(env) {
    return encoder.encode(JSON.stringify(env));
}
export function decodeEnvelope(bytes) {
    const parsed = JSON.parse(decoder.decode(bytes));
    if (parsed == null || parsed.v !== ENVELOPE_VERSION || typeof parsed.t !== 'string') {
        throw new Error('malformed envelope');
    }
    return parsed;
}
/** Build a message envelope. */
export function messageEnvelope(text) {
    return { v: 1, t: 'm', x: text };
}
/** Build a read-acknowledgment envelope for a received capsule. */
export function ackEnvelope(lane, seq) {
    return { v: 1, t: 'a', l: lane, s: seq };
}
/** Build a coordinated self-destruct (burn) envelope. */
export function burnEnvelope(reason) {
    return reason === undefined ? { v: 1, t: 'burn' } : { v: 1, t: 'burn', r: reason };
}
/**
 * Zero-fill a transient byte buffer (e.g. a decoded plaintext) once consumed.
 * Note: this wipes BYTES only — a JS string derived from them cannot be zeroed.
 */
export function wipeBytes(bytes) {
    bytes.fill(0);
}
//# sourceMappingURL=protocol.js.map